// ADDED: Service to handle bulk log generation
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

export const employeeTimeRecordService = {
  /**
   * Fetches filtered time entries for the "Upload" tab
   * @param {Object} payload { payrollPeriodId, payTypeId, filters }
   */
  getPreview: async (payload) => { // commented on the backend
    return await axios.post(`${domain}/api/EmployeeTimeRecord/preview`, payload, { headers });
  },
  generateFixedLogs: async (payload) => {
    const response = await axios.post(`${domain}/api/EmployeeTimeRecord/generate-fixed-logs`, payload, { headers });
    return response.data;
  },
  generateFixedLogsByEmployee: async (payload) => {
    const response = await axios.post(`${domain}/api/EmployeeTimeRecord/generate-fixed-logs-by-employee`, payload, { headers });
    return response.data;
  }
};